import React from 'react';
import "./skills.css"
const AiTechniques = () =>{

    return(
        <div className="skills__content">
        <h3 className="skills__title">Artificial Intelligence</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">LLM FineTuning</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Mathematics</h3>
                    <span className="skills__level">Avanced</span>
                </div>
                </div>


                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">RAG</h3>
                    <span className="skills__level">Advanced</span>
                </div>
                </div>
                
            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Reinforcement Learning</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>
                <div>
                    <h3 className="skills__name">Statistics</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check'></i>
                <div>
                    <h3 className="skills__name">Agentic AI</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

            </div>

            
        </div>
    </div>
    )
}


export default AiTechniques